export default [{
		path: '/temp/index',
		name: 'temp-index',
		component: () => import('@/projects/temp/Page'),
		meta: {
			title: '无关路由',
			index: 0,
		}
	},
	// {
	// 	path: '/temp/shop',
	// 	name: 'shop',
	// 	component: () => import('@/projects/temp/shop'),
	// 	meta: {
	// 		title: '商家详情',
	// 		index: 0,
	// 	}
	// }
]


// WEBPACK FOOTER //
// ./src/projects/temp/index.js